import { Component, h } from 'preact'
import { IdeaStatus } from '../../../control-components/ideation-status/Types'
import Phrase from '../../../libs/translationsUtils/phrase'
import InputGroup from '../../../control-components/ui-components/InputGroup'
import qs from 'qs'
import Portal from 'preact-portal'

interface Props {
  ideationStatuses: Array<IdeaStatus>,
  selectedIdeationStatus: null | string
}

interface State {
  selectedIdeationStatus: null | string,
  selectedIdeationStatusBeforeFiltersApply: null | string,
  setPortal: boolean
}

export class IdeaStatusFilter extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      selectedIdeationStatus: props.selectedIdeationStatus === null ? null : props.selectedIdeationStatus,
      selectedIdeationStatusBeforeFiltersApply: null,
      setPortal: false
    }
    this.setQueryParams = this.setQueryParams.bind(this)
    this.setSelectedIdeationStatus = this.setSelectedIdeationStatus.bind(this)
    this.updatePortalSetting = this.updatePortalSetting.bind(this)
  }

  setQueryParams (newStatus: string | null) {
    const searchQuery = window.location.search
    let queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })

    delete queryParameters?.filters?.ideationStatus

    let newQuery = newStatus === null ? { filters: queryParameters?.filters || {} } : { filters: { ...queryParameters?.filters || {}, ideationStatus: [newStatus] } }

    let combinedQuery = { ...queryParameters, ...newQuery }

    delete combinedQuery?.page

    window.history.pushState('', '', `?${qs.stringify(combinedQuery)}`)
  }

  setSelectedIdeationStatus (newStatus: string | null) {
    this.setState({ selectedIdeationStatus: newStatus })
    this.setQueryParams(newStatus)
  }

  updatePortalSetting (evt: CustomEvent) {
    this.setState({
      selectedIdeationStatusBeforeFiltersApply: this.state.selectedIdeationStatus,
      setPortal: evt.detail.display
    })
  }

  ListItem (name: string | null) {
    return (
      <li
        className={this.state.selectedIdeationStatus === name ? 'selected' : ''}
        onClick={() => this.setSelectedIdeationStatus(name)}
        onKeyUp={(e) => e.code === 'Enter' ? this.setSelectedIdeationStatus(name) : null}
        role='button'
        tabIndex={0}
      >
        <div className='vertical-line' />
        {
          name === null ? <Phrase p='all.statuses' /> : <span>{ name }</span>
        }
      </li>
    )
  }

  componentDidMount () {
    window.addEventListener('filter', (this.updatePortalSetting) as EventListener)
    window.addEventListener('resetFilters', () => this.setSelectedIdeationStatus(null))
    window.addEventListener('revertFilters', () => this.setSelectedIdeationStatus(this.state.selectedIdeationStatusBeforeFiltersApply))
    window.addEventListener('ideationStatusFilterRemoval', () => this.setSelectedIdeationStatus(null))
  }

  componentWillUnmount () {
    window.removeEventListener('filter', (this.updatePortalSetting) as EventListener)
    window.removeEventListener('resetFilters', () => this.setSelectedIdeationStatus(null))
    window.removeEventListener('revertFilters', () => this.setSelectedIdeationStatus(this.state.selectedIdeationStatusBeforeFiltersApply))
    window.removeEventListener('ideationStatusFilterRemoval', () => this.setSelectedIdeationStatus(null))
  }

  render ({ ideationStatuses }: Props, { selectedIdeationStatus, setPortal }: State) {
    return (
      <div>
        <div className='box__content box__pad ideation-filters is-hidden-M'>
          <h3 className='widget-title'><Phrase p='filter.by.idea.status' /></h3>
          <ul className='ideation-filters__idea-status'>
            {
              this.ListItem(null)
            }
            {
              ideationStatuses.map(({ name }) => this.ListItem(name))
            }
          </ul>
        </div>
        {
          setPortal ? (
            <Portal into='.instant-search__results-wrapper-filters'>
              <div className='box__content box__pad ideation-filters'>
                <h3 className='widget-title'><Phrase p='filter.by.idea.status' /></h3>
                <ul className='ideation-filters__idea-status'>
                  {
                    this.ListItem(null)
                  }
                  {
                    ideationStatuses.map(({ name }) => this.ListItem(name))
                  }
                </ul>
              </div>
            </Portal>
          ) : null
        }
      </div>
    )
  }
}

interface PropsForConfigurator {
  title: string,
  onChange: (state: {title: string}) => void
}

interface StateForConfigurator {
  title: string
}

export class IdeaStatusFilterWithHelp extends Component<PropsForConfigurator, StateForConfigurator> {
  constructor (props: PropsForConfigurator) {
    super(props)
    this.state = {
      title: props.title
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, () => this.props.onChange(this.state))
  }

  render (_: PropsForConfigurator, { title }: StateForConfigurator) {
    return (
      <div className=''>
        <InputGroup
          title='Title'
          name='title'
          placeholder='Add a title'
          type='text'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />
      </div>
    )
  }
}

export default IdeaStatusFilter
